import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import type { EntityCellProps } from '../../../../model/index.tsx';
import { getShares } from '../../../../state/selectors/filters/index.tsx';
import type { State } from '../../../../state/types.tsx';
import Access from './view.tsx';

const mapStateToProps = () => (state: State, ownProps: EntityCellProps) => ({
	shares: getShares(state, ownProps.id),
});

export default connect(mapStateToProps, {})(Access);
